import { render, staticRenderFns } from "./analysis.vue?vue&type=template&id=05327c10&scoped=true&"
import script from "./analysis.vue?vue&type=script&lang=js&"
export * from "./analysis.vue?vue&type=script&lang=js&"
import style0 from "./analysis.vue?vue&type=style&index=0&id=05327c10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05327c10",
  null
  
)

export default component.exports